/**
 *
 * @module entry
 * @desc {SDK.Services.Drm} entry point.
 *
 */

import DrmClient from './drmClient';
import DrmClientConfiguration from './drmClientConfiguration';
import DrmClientEndpoint from './drmClientEndpoint';
import PlayReadyMessage from './playReadyMessage';

/**
 *
 * @typedef SDK.Services.Drm
 * @type {Object}
 *
 * @property {DrmClient} DrmClient
 * @property {DrmClientConfiguration} DrmClientConfiguration
 * @property {DrmCLientEndpoint} DrmClientEndpoint
 * @property {PlayReadyMessage} PlayReadyMessage
 *
 */

/**
 *
 * @type {SDK.Services.Drm}
 *
 */
export default {

    DrmClient,
    DrmClientConfiguration,
    DrmClientEndpoint,
    PlayReadyMessage

};



// WEBPACK FOOTER //
// ./src/services/drm/entry.js